import type {SortSelectionObject} from '../common';
import {FilterMetadataMap, FromFilterDefinition, NonNullableFilterValues, NullableFilterValues,} from '../filtering';

export const TEMPLATE_SORT_COLUMNS = {
    name: 'name',
    title: 'title',
} as const;

export const TEMPLATE_DEFAULT_SORT: SortSelectionObject<
    typeof TEMPLATE_SORT_COLUMNS
> = {column: 'name', direction: 'asc'};

export const TEMPLATE_FILTER_DEFINITION = {
    search: 'string',
    client: 'string[]',
    project: 'string[]',
    type: 'string[]',
} as const;

export const TEMPLATE_TYPE_VALUES = [
    'Initial Visit',
    'Abort - Billable',
    'Abort - Not Billable',
    'Revisit - Billable',
    'Revisit - Not Billable',
    'Reschedule',
    'Warranty',
    'SCM',
    'Materials',
    'Lift',
] as const;

export const TEMPLATE_FILTER_METADATA = {
    type: {
        kind: 'enum' as const,
        enumValues: TEMPLATE_TYPE_VALUES,
        isArray: true,
    }
} as const satisfies FilterMetadataMap<typeof TEMPLATE_FILTER_DEFINITION>;

export type TemplateFilterDefinition = FromFilterDefinition<
    typeof TEMPLATE_FILTER_DEFINITION
>;
export type NullableTemplateFilter =
    NullableFilterValues<TemplateFilterDefinition>;
export type NonNullableTemplateFilter =
    NonNullableFilterValues<TemplateFilterDefinition>;

export const DEFAULT_TEMPLATE_FILTER: NullableTemplateFilter = {
    search: null,
    client: null,
    project: null,
    type: null,
};
